import { render, staticRenderFns } from "./ModelRewardConfig.vue?vue&type=template&id=2dfb2462&scoped=true"
import script from "./ModelRewardConfig.vue?vue&type=script&lang=js"
export * from "./ModelRewardConfig.vue?vue&type=script&lang=js"
import style0 from "./ModelRewardConfig.vue?vue&type=style&index=0&id=2dfb2462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb2462",
  null
  
)

export default component.exports